/**
 * @generated SignedSource<<8ef580dcd4310e602fc2dd28fb0d9b47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionMapElementFeatureAttribute_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "PageSectionMapElementFeatureAttribute",
  "abstractKey": null
};

node.hash = "4b8c8c88015f212962f0d392c22e158b";

module.exports = node;
